const VIDEO_PATH = '/build/assets/videos';
const VIDEO_SRC = `<source src="${VIDEO_PATH}/home-page-video-2.mp4" type="video/mp4">`;
const PLAY_TIME = 40_000;
const LOADING_DELAY = 6_000;

export const initHomeVideo = (): void => {
    const videoEl = document.getElementById('video-greeting') as HTMLVideoElement | null;
    const progressBar = document.querySelector<HTMLElement>('.progress-bar');
    const mainWrp = document.querySelector<HTMLElement>('.main-wrp');

    if (!videoEl || !progressBar || !mainWrp) return;

    const countdown = (+videoEl.getAttribute('data-countdown')! || 0) + LOADING_DELAY / 2;

    // Mobile/tablet: remove video, show static background
    if (window.innerWidth < 1024 || window.innerHeight >= 1366) {
        videoEl.remove();
        progressBar.remove();
        mainWrp.style.visibility = 'visible';
        return;
    }

    mainWrp.style.visibility = 'visible';

    let removed = false;
    let inView = true;

    // #parallax is position:fixed, so the video never leaves the viewport itself —
    // observe the hero section instead and pause while it is scrolled away.
    const watchVisibility = (): void => {
        const hero = document.getElementById('hero');

        const sync = (): void => {
            if (removed) return;
            if (inView && !document.hidden) {
                if (videoEl.paused) videoEl.play();
            } else if (!videoEl.paused) {
                videoEl.pause();
            }
        };

        document.addEventListener('visibilitychange', sync);

        if (hero && 'IntersectionObserver' in window) {
            new IntersectionObserver(
                (entries) => {
                    inView = entries[0].isIntersecting;
                    sync();
                },
                { threshold: 0 },
            ).observe(hero);
        }
    };

    const startPlay = (): void => {
        progressBar.classList.remove('progress-bar-active');
        videoEl.parentElement?.classList.add('parallax-overlay-black');
        videoEl.style.opacity = '1';
        videoEl.play();
        videoEl.removeEventListener('canplaythrough', startPlay);
        watchVisibility();
        setTimeout(removeVideo, PLAY_TIME);
    };

    const removeVideo = (): void => {
        removed = true;
        videoEl.pause();
        progressBar.remove();
        videoEl.remove();
    };

    const injectVideo = (): void => {
        videoEl.innerHTML = VIDEO_SRC;
        videoEl.load();
    };

    videoEl.addEventListener('canplaythrough', startPlay);

    if (document.readyState === 'complete') {
        scheduleIdle(injectVideo);
    } else {
        window.addEventListener('load', () => scheduleIdle(injectVideo), { once: true });
    }

    progressBar.classList.add('progress-bar-active');
    progressBar.style.animationDuration = countdown + 'ms';
};

const scheduleIdle = (fn: () => void): void => {
    if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(fn, { timeout: LOADING_DELAY });
    } else {
        setTimeout(fn, 1000);
    }
};
